<template>
  <v-app>
    <link
      href="https://cdn.jsdelivr.net/npm/animate.css@3.5.1"
      rel="stylesheet"
      type="text/css"
    />

    <!-- ローディング画面 -->
    <v-overlay v-model="isLoading" class="loading-overlay" persistent>
      <div class="loading-content">
        <v-progress-circular
          indeterminate
          size="64"
          width="6"
          color="primary"
        ></v-progress-circular>
        <p class="loading-text">環境クイズを読み込み中...</p>
        <p class="loading-subtext">{{ loadedImages }}/23 画像</p>
      </div>
    </v-overlay>

    <!-- 進捗カウンター -->
    <div class="progress-counter">
      <v-chip
        color="primary"
        size="large"
        class="progress-chip"
      >
        <v-icon start>mdi-check-circle</v-icon>
        {{ results_count }}/10 正解
      </v-chip>
      <v-progress-linear
        :model-value="(results_count / 10) * 100"
        color="success"
        height="8"
        rounded
        class="progress-bar"
      ></v-progress-linear>
    </div>

    <div class="map">
      <!-- <KamiFubuki /> -->
      <!-- 背景画像は正解数によって差し替わる -->
      <transition appear name="hoge">
        <div v-if="results_count < 5">
          <img
            src="https://cct-study.com/images/bad_river.png"
            alt="汚染された川と街の風景"
            class="bad-earth"
          />
        </div>
      </transition>
      <transition>
        <div
          v-if="(results_count > 5 && results_count < 10) || results_count == 5"
        >
          <img
            src="https://cct-study.com/images/normal_river.png"
            alt="改善されつつある川と街の風景"
            class="normal-earth"
          />
        </div>
      </transition>
      <transition appear name="hoge">
        <div v-if="results_count >= 10">
          <img
            src="https://cct-study.com/images/good_river.png"
            alt="きれいになった川と街の風景"
            class="good-earth"
          />
        </div>
      </transition>

      <!-- 全問正解時のおめでとうメッセージ -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated zoomInDown"
        leave-active-class=""
      >
        <div class="congrats-msg" v-if="results_count == 10 && !congrats_msg_flg">
          全問正解！<br />みんなのおかげで街がきれいになったね<br />
          <v-btn
            class="congrats-msg-close"
            color="Primary"
            variant="text"
            @click="close_cong()"
            >閉じる</v-btn
          >
        </div>
      </transition>

      <!-- Q1のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img01" v-if="select1_result_bef">
          <img
            src="https://cct-study.com/images/q1/before_hageyama.png"
            alt="問題1: はげ山の環境問題"
            class=""
          />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img01" v-if="select1_result_aft">
          <img
            src="https://cct-study.com/images/q1/after_hageyama.png"
            alt="問題1: 解決済み - 緑豊かな山"
            class="solved-image"
          />
        </div>
      </transition>
      <!-- Q2のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img02" v-if="select2_result_bef">
          <img
            src="https://cct-study.com/images/q2/before_hatake.png"
            alt="問題2: 作物への温暖化の影響"
            class=""
          />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img02" v-if="select2_result_aft">
          <img
            src="https://cct-study.com/images/q2/after_hatake.png"
            alt="問題2: 解決済み - 健康な作物"
            class="solved-image"
          />
        </div>
      </transition>
      <!-- Q3のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img03" v-if="select3_result_bef">
          <img
            src="https://cct-study.com/images/q3/before_doshakuzure.png"
            alt="問題3: 土砂崩れの危険"
            class=""
          />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img03" v-if="select3_result_aft">
          <img
            src="https://cct-study.com/images/q3/after_doshakuzure.png"
            alt="問題3: 解決済み - 安全な斜面"
            class="solved-image"
          />
        </div>
      </transition>
      <!-- Q4のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img04" v-if="select4_result_bef">
          <img
            src="https://cct-study.com/images/q4/before_rakuno.png"
            alt="問題4: 乳牛への温暖化の影響"
            class=""
          />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img04" v-if="select4_result_aft">
          <img
            src="https://cct-study.com/images/q4/after_rakuno.png"
            alt="問題4: 解決済み - 元気な乳牛"
            class="solved-image"
          />
        </div>
      </transition>
      <!-- Q5のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img05" v-if="select5_result_bef">
          <img
            src="https://cct-study.com/images/q5/before_teiden.png"
            alt="問題5: 停電した家"
            class=""
          />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img05" v-if="select5_result_aft">
          <img
            src="https://cct-study.com/images/q5/after_teiden.png"
            alt="問題5: 解決済み - 自家発電の家"
            class="solved-image"
          />
        </div>
      </transition>
      <!-- Q6のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img06" v-if="select6_result_bef">
          <img
            src="https://cct-study.com/images/q6/before_squall.png"
            alt="問題6: 豪雨被害"
            class=""
          />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img06" v-if="select6_result_aft">
        </div>
      </transition>
      <!-- Q7のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img07" v-if="select7_result_bef">
          <img src="https://cct-study.com/images/q7/before_ka.png" alt="問題7: 蚊の増加" class="" />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img07" v-if="select7_result_aft">
        </div>
      </transition>
      <!-- Q8のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img08" v-if="select8_result_bef">
          <img src="https://cct-study.com/images/q8/before_boy.png" alt="問題8: 熱中症のリスク" class="" />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img08" v-if="select8_result_aft">
          <img src="https://cct-study.com/images/q8/after_boy.png" alt="問題8: 解決済み - 元気な子ども" class="solved-image" />
        </div>
      </transition>
      <!-- Q9のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img09" v-if="select9_result_bef">
          <img
            src="https://cct-study.com/images/q9/before_gaslinecar.png"
            alt="問題9: ガソリン車の排気ガス"
            class=""
          />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img09" v-if="select9_result_aft">
          <img
            src="https://cct-study.com/images/q9/after_gaslinecar.png"
            alt="問題9: 解決済み - 電気自動車"
            class="solved-image"
          />
        </div>
      </transition>
      <!-- Q10のマップ上画像 -->
      <transition
        name="custom-classes-transition"
        enter-active-class="animated fadeIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img10" v-if="select10_result_bef">
          <img
            src="https://cct-study.com/images/q10/before_karyoku.png"
            alt="問題10: 火力発電所"
            class=""
          />
        </div>
      </transition>
      <transition
        name="custom-classes-transition"
        enter-active-class="animated bounceIn"
        leave-active-class="animated fadeOut"
      >
        <div class="inline-img10" v-if="select10_result_aft">
          <img
            src="https://cct-study.com/images/q10/after_karyoku.png"
            alt="問題10: 解決済み - 太陽光発電"
            class="solved-image"
          />
        </div>
      </transition>

      <!-- [Q1.はげ山]ダイアログ部分 - 1 ここから -->
      <v-dialog v-model="dialog1" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img01" v-if="select1_result_bef">
            <img
              src="https://cct-study.com/images/q1/before_hageyama.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題1: はげ山の環境問題について学ぶ"
              @keydown="openDialogOnKeypress(1, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >山の木がなくなると、どのような影響があるでしょうか？</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu1">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success1">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q1/01_a.png"
                class="select-item"
                @click="select1_current()"
              />
              <p>二酸化炭素が吸収できなくなる</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q1/01_b.png"
                class="select-item"
                @click="select1_fault()"
              />
              <p>山に住む動物が増える</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q1/01_c.png"
                class="select-item"
                @click="select1_fault()"
              />
              <p>土砂崩れが起きなくなる</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 1 ここまで -->

      <!-- [Q2.作物]ダイアログ部分 - 2 ここから -->
      <v-dialog v-model="dialog2" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img02" v-if="select2_result_bef">
            <img
              src="https://cct-study.com/images/q2/before_hatake.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題2: 地球温暖化による作物への影響について学ぶ"
              @keydown="openDialogOnKeypress(2, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >地球温暖化によりお米の栽培にどのような影響があるでしょうか？</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu2">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success2">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q2/02_a.png"
                class="select-item"
                @click="select2_fault()"
              />
              <p>お米の品質が良くなる</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q2/02_b.png"
                class="select-item"
                @click="select2_fault()"
              />
              <p>何も変わらない</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q2/02_c.png"
                class="select-item"
                @click="select2_current()"
              />
              <p>お米の品質が悪くなる</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 2 ここまで -->

      <!-- [Q3.土砂崩れ]ダイアログ部分 - 3 ここから -->
      <v-dialog v-model="dialog3" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img03" v-if="select3_result_bef">
            <img
              src="https://cct-study.com/images/q3/before_doshakuzure.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題3: 集中豪雨による災害について学ぶ"
              @keydown="openDialogOnKeypress(3, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >地球温暖化により集中豪雨が増えると、どのような災害が起こるでしょうか?</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu3">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success3">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q3/03_a.jpg"
                class="select-item"
                @click="select3_fault()"
              />
              <p>地震</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q3/03_b.png"
                class="select-item"
                @click="select3_current()"
              />
              <p>土砂崩れ</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q3/03_c.jpg"
                class="select-item"
                @click="select3_fault()"
              />
              <p>噴火</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 3 ここまで -->

      <!-- [Q4.ウシ]ダイアログ部分 - 4 ここから -->
      <v-dialog v-model="dialog4" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img04" v-if="select4_result_bef">
            <img
              src="https://cct-study.com/images/q4/before_rakuno.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題4: 家畜からの温室効果ガスについて学ぶ"
              @keydown="openDialogOnKeypress(4, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >地球温暖化により乳牛に起こる影響はどれでしょうか？</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu4">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success4">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q4/04_a.jpg"
                class="select-item"
                @click="select4_current()"
              />
              <p>牛乳の量が減る</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q4/04_b.png"
                class="select-item"
                @click="select4_fault()"
              />
              <p>体が大きく成長する</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q4/04_c.png"
                class="select-item"
                @click="select4_fault()"
              />
              <p>子どもを多く生む</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 4 ここまで -->

      <!-- [Q5.停電した家]ダイアログ部分 - 5 ここから -->
      <v-dialog v-model="dialog5" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img05" v-if="select5_result_bef">
            <img
              src="https://cct-study.com/images/q5/before_teiden.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題5: 停電対策について学ぶ"
              @keydown="openDialogOnKeypress(5, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >災害が起きて停電したときどんな家だと安心でしょうか？</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu5">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success5">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q5/05_a.png"
                class="select-item"
                @click="select5_fault()"
              />
              <p>自宅で野菜を作る家</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q5/05_b.png"
                class="select-item"
                @click="select5_current()"
              />
              <p>自宅で電気を作る家</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q5/05_c.png"
                class="select-item"
                @click="select5_fault()"
              />
              <p>頑丈な家</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 5 ここまで -->

      <!-- [Q6.豪雨被害]ダイアログ部分 - 6 ここから -->
      <v-dialog v-model="dialog6" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img06" v-if="select6_result_bef">
            <img
              src="https://cct-study.com/images/q6/before_squall.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題6: 豪雨被害対策について学ぶ"
              @keydown="openDialogOnKeypress(6, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >地球温暖化が進むと天気にどのような影響を与えるでしょうか？</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu6">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success6">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q6/06_a.png"
                class="select-item"
                @click="select6_fault()"
              />
              <p>雪の降る日が増える</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q6/06_b.jpg"
                class="select-item"
                @click="select6_fault()"
              />
              <p>過ごしやすい日が増える</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q6/06_c.png"
                class="select-item"
                @click="select6_current()"
              />
              <p>集中豪雨が増える</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 6 ここまで -->

      <!-- [Q7.蚊]ダイアログ部分 - 7 ここから -->
      <v-dialog v-model="dialog7" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img07" v-if="select7_result_bef">
            <img
              src="https://cct-study.com/images/q7/before_ka.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題7: 温暖化による感染症について学ぶ"
              @keydown="openDialogOnKeypress(7, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >地球温暖化により蚊が増えると、どのような影響があるでしょうか？</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu7">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success7">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q7/07_a.png"
                class="select-item"
                @click="select7_fault()"
              />
              <p>川の水が汚くなる</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q7/07_b.png"
                class="select-item"
                @click="select7_current()"
              />
              <p>感染症が増える</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q7/07_c.jpg"
                class="select-item"
                @click="select7_fault()"
              />
              <p>二酸化炭素が減る</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 7 ここまで -->

      <!-- [Q8.子ども]ダイアログ部分 - 8 ここから -->
      <v-dialog v-model="dialog8" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img08" v-if="select8_result_bef">
            <img
              src="https://cct-study.com/images/q8/before_boy.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題8: 熱中症対策について学ぶ"
              @keydown="openDialogOnKeypress(8, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >地球温暖化により私たちはどんな病気になりやすくなるでしょうか？</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu8">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success8">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q8/08_a.png"
                class="select-item"
                @click="select8_current()"
              />
              <p>熱中症</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q8/08_b.png"
                class="select-item"
                @click="select8_fault()"
              />
              <p>花粉症</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q8/08_c.png"
                class="select-item"
                @click="select8_fault()"
              />
              <p>高所恐怖症</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 8 ここまで -->

      <!-- [Q9.自動車]ダイアログ部分 - 9 ここから -->
      <v-dialog v-model="dialog9" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img09" v-if="select9_result_bef">
            <img
              src="https://cct-study.com/images/q9/before_gaslinecar.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題9: 環境にやさしい車について学ぶ"
              @keydown="openDialogOnKeypress(9, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >どのような車がいちばん環境にやさしい車でしょうか？</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu9">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success9">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q9/09_a.png"
                class="select-item"
                @click="select9_fault()"
              />
              <p>軽自動車</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q9/09_b.png"
                class="select-item"
                @click="select9_current()"
              />
              <p>電気自動車</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q9/09_c.png"
                class="select-item"
                @click="select9_fault()"
              />
              <p>ハイブリッド車</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 9 ここまで -->

      <!-- [Q10.発電所]ダイアログ部分 - 10 ここから -->
      <v-dialog v-model="dialog10" width="80%">
        <template v-slot:activator="{ props }">
          <div class="inline-img10" v-if="select10_result_bef">
            <img
              src="https://cct-study.com/images/q10/before_karyoku.png"
              v-bind="props"
              class="switch_image"
              tabindex="0"
              role="button"
              aria-label="問題10: 環境にやさしい発電方法について学ぶ"
              @keydown="openDialogOnKeypress(10, $event)"
            />
          </div>
        </template>

        <v-card>
          <v-card-title class="text-h5 font-weight-bold bg-yellow-lighten-2"
            >自然の力を利用した環境にやさしい発電方法はどれでしょうか？</v-card-title
          >
          <div class="sub-title-text">
            次のうち一番当てはまるものはどれでしょうか？
          </div>
          <v-card-text v-if="batsu10">
            <div class="mistake-text">❌ 間違いです</div>
          </v-card-text>
          <v-card-text v-if="success10">
            <div class="success-text">✅ 正解です！</div>
          </v-card-text>
          <v-card-actions>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q10/10_a.png"
                class="select-item"
                @click="select10_fault()"
              />
              <p>原子力発電</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q10/10_b.png"
                class="select-item"
                @click="select10_fault()"
              />
              <p>火力発電</p>
            </div>
            <div class="inline-sel">
              <img
                src="https://cct-study.com/images/q10/10_c.png"
                class="select-item"
                @click="select10_current()"
              />
              <p>太陽光発電</p>
            </div>
          </v-card-actions>

          <!-- Divider:水平線を描画 -->
          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="Primary" variant="text" @click="close()">閉じる</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- ダイアログ部分 - 10 ここまで -->
    </div>
  </v-app>
</template>

<script>
// import KamiFubuki from './components/KamiFubuki.vue'

export default {
  components: {
    // KamiFubuki
  },
  data() {
    return {
      isLoading: true,
      loadedImages: 0,
      totalImages: 23,
      results_count: 0,
      congrats_msg_flg: false,
      dialog1: false,
      dialog2: false,
      dialog3: false,
      dialog4: false,
      dialog5: false,
      dialog6: false,
      dialog7: false,
      dialog8: false,
      dialog9: false,
      dialog10: false,
      select1_result_bef: true,
      select1_result_aft: false,
      select2_result_bef: true,
      select2_result_aft: false,
      select3_result_bef: true,
      select3_result_aft: false,
      select4_result_bef: true,
      select4_result_aft: false,
      select5_result_bef: true,
      select5_result_aft: false,
      select6_result_bef: true,
      select6_result_aft: false,
      select7_result_bef: true,
      select7_result_aft: false,
      select8_result_bef: true,
      select8_result_aft: false,
      select9_result_bef: true,
      select9_result_aft: false,
      select10_result_bef: true,
      select10_result_aft: false,
      batsu1: false,
      batsu2: false,
      batsu3: false,
      batsu4: false,
      batsu5: false,
      batsu6: false,
      batsu7: false,
      batsu8: false,
      batsu9: false,
      batsu10: false,
      success1: false,
      success2: false,
      success3: false,
      success4: false,
      success5: false,
      success6: false,
      success7: false,
      success8: false,
      success9: false,
      success10: false,
    };
  },
  methods: {
    openDialogOnKeypress(dialogNum, event) {
      // Open dialog on Enter or Space key
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        this['dialog' + dialogNum] = true;
      }
    },
    close() {
      this.batsu1 = false;
      this.batsu2 = false;
      this.batsu3 = false;
      this.batsu4 = false;
      this.batsu5 = false;
      this.batsu6 = false;
      this.batsu7 = false;
      this.batsu8 = false;
      this.batsu9 = false;
      this.batsu10 = false;
      this.success1 = false;
      this.success2 = false;
      this.success3 = false;
      this.success4 = false;
      this.success5 = false;
      this.success6 = false;
      this.success7 = false;
      this.success8 = false;
      this.success9 = false;
      this.success10 = false;
      this.dialog1 = false;
      this.dialog2 = false;
      this.dialog3 = false;
      this.dialog4 = false;
      this.dialog5 = false;
      this.dialog6 = false;
      this.dialog7 = false;
      this.dialog8 = false;
      this.dialog9 = false;
      this.dialog10 = false;
    },
    close_cong() {
      this.congrats_msg_flg = true;
    },
    select1_current() {
      this.success1 = true;
      this.batsu1 = false;
      setTimeout(() => {
        this.select1_result_bef = false;
        this.select1_result_aft = true;
        this.dialog1 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select1_fault() {
      this.batsu1 = true;
    },
    select2_current() {
      this.success2 = true;
      this.batsu2 = false;
      setTimeout(() => {
        this.select2_result_bef = false;
        this.select2_result_aft = true;
        this.dialog2 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select2_fault() {
      this.batsu2 = true;
    },
    select3_current() {
      this.success3 = true;
      this.batsu3 = false;
      setTimeout(() => {
        this.select3_result_bef = false;
        this.select3_result_aft = true;
        this.dialog3 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select3_fault() {
      this.batsu3 = true;
    },
    select4_current() {
      this.success4 = true;
      this.batsu4 = false;
      setTimeout(() => {
        this.select4_result_bef = false;
        this.select4_result_aft = true;
        this.dialog4 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select4_fault() {
      this.batsu4 = true;
    },
    select5_current() {
      this.success5 = true;
      this.batsu5 = false;
      setTimeout(() => {
        this.select5_result_bef = false;
        this.select5_result_aft = true;
        this.dialog5 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select5_fault() {
      this.batsu5 = true;
    },
    select6_current() {
      this.success6 = true;
      this.batsu6 = false;
      setTimeout(() => {
        this.select6_result_bef = false;
        this.select6_result_aft = true;
        this.dialog6 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select6_fault() {
      this.batsu6 = true;
    },
    select7_current() {
      this.success7 = true;
      this.batsu7 = false;
      setTimeout(() => {
        this.select7_result_bef = false;
        this.select7_result_aft = true;
        this.dialog7 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select7_fault() {
      this.batsu7 = true;
    },
    select8_current() {
      this.success8 = true;
      this.batsu8 = false;
      setTimeout(() => {
        this.select8_result_bef = false;
        this.select8_result_aft = true;
        this.dialog8 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select8_fault() {
      this.batsu8 = true;
    },
    select9_current() {
      this.success9 = true;
      this.batsu9 = false;
      setTimeout(() => {
        this.select9_result_bef = false;
        this.select9_result_aft = true;
        this.dialog9 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select9_fault() {
      this.batsu9 = true;
    },
    select10_current() {
      this.success10 = true;
      this.batsu10 = false;
      setTimeout(() => {
        this.select10_result_bef = false;
        this.select10_result_aft = true;
        this.dialog10 = false;
        this.results_count = this.results_count + 1;
        console.log(this.results_count);
      }, 1000);
    },
    select10_fault() {
      this.batsu10 = true;
    },
  },
  mounted() {
    // 画像URLのリスト
    const imageUrls = [
      // 背景画像3枚
      'https://cct-study.com/images/bad_river.png',
      'https://cct-study.com/images/normal_river.png',
      'https://cct-study.com/images/good_river.png',
      // 問題画像20枚
      'https://cct-study.com/images/q1/before_hageyama.png',
      'https://cct-study.com/images/q1/after_hageyama.png',
      'https://cct-study.com/images/q2/before_hatake.png',
      'https://cct-study.com/images/q2/after_hatake.png',
      'https://cct-study.com/images/q3/before_doshakuzure.png',
      'https://cct-study.com/images/q3/after_doshakuzure.png',
      'https://cct-study.com/images/q4/before_rakuno.png',
      'https://cct-study.com/images/q4/after_rakuno.png',
      'https://cct-study.com/images/q5/before_teiden.png',
      'https://cct-study.com/images/q5/after_teiden.png',
      'https://cct-study.com/images/q6/before_squall.png',
      'https://cct-study.com/images/q6/after_squall.png',
      'https://cct-study.com/images/q7/before_ka.png',
      'https://cct-study.com/images/q7/after_ka.png',
      'https://cct-study.com/images/q8/before_boy.png',
      'https://cct-study.com/images/q8/after_boy.png',
      'https://cct-study.com/images/q9/before_gaslinecar.png',
      'https://cct-study.com/images/q9/after_gaslinecar.png',
      'https://cct-study.com/images/q10/before_karyoku.png',
      'https://cct-study.com/images/q10/after_karyoku.png',
    ];

    // 画像プリロード処理
    const preloadImages = imageUrls.map(url => {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          this.loadedImages++;
          resolve();
        };
        img.onerror = () => {
          this.loadedImages++;
          resolve(); // エラーでも進める
        };
        img.src = url;
      });
    });

    // 全画像の読み込み完了を待つ
    Promise.all(preloadImages).then(() => {
      setTimeout(() => {
        this.isLoading = false;
      }, 500); // 0.5秒の余裕を持たせる
    });
  },
};
</script>

<style scoped>
/* iframe対応 - 余白を削除 */
.v-application {
  background: transparent !important;
}

.v-application__wrap {
  min-height: auto !important;
}

/* ローディング画面 */
.loading-overlay {
  z-index: 9999 !important;
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.loading-text {
  color: white;
  font-size: 20px;
  font-weight: bold;
  margin: 0;
}

.loading-subtext {
  color: rgba(255, 255, 255, 0.8);
  font-size: 16px;
  margin: 0;
}

.map {
  position: relative;  /* 子要素の絶対配置の基準点 */
  width: 100%;
  max-width: 1022px;
  margin: 0 auto;
  /* iframe内では自然な高さに任せる */
}
.map img {
  width: 100%;
  height: auto;
  max-width: 1022px;
  display: block;
}
/* v-card-actionsを中央揃えに（Vuetify v2/v3両対応） */
.v-card__actions,
.v-card-actions {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  flex-wrap: wrap !important;
  gap: 10px !important;
}
.congrats-msg {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin: 0;
  font-size: 30px;
  color: #fff;
  z-index: 100;
  background-color: #008000;
  padding: 2rem;
  text-align: center;
  border-radius: 1rem;
  border: solid 0.5rem #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}
/* Vuetify v3ボタン対応 */
.congrats-msg-close {
  margin-top: 1rem !important;
  min-width: 120px !important;
}
/* ボタン内部の文字色とスタイル */
.congrats-msg-close :deep(.v-btn__content) {
  font-size: 24px !important;
  color: #fff !important;
}
.inline-img01 {
  position: absolute;
  top: 50px;
  left: 0px;
  z-index: 1;
}
.inline-img01 img {
  height: 150px;
  width: auto;
  z-index: 1;
}

.inline-img02 {
  position: absolute;
  top: 230px;
  left: 10px;
  z-index: 2;
}
.inline-img02 img {
  height: auto;
  width: 450px;
  z-index: 2;
  /* background-color: blue; */
}

.inline-img03 {
  position: absolute;
  top: 50px;
  left: 575px;
  z-index: 3;
}
.inline-img03 img {
  height: 220px;
  width: auto;
  z-index: 3;
}

.inline-img04 {
  position: absolute;
  top: 300px;
  left: 50px;
  z-index: 4;
}
.inline-img04 img {
  height: 200px;
  width: auto;
  z-index: 4;
  /* background-color: green; */
}

.inline-img05 {
  position: absolute;
  top: 300px;
  left: 675px;
  z-index: 5;
}
.inline-img05 img {
  height: 170px;
  width: auto;
  z-index: 5;
  /* background-color: red; */
}

.inline-img06 {
  position: absolute;
  top: 0px;
  left: 500px;
  z-index: 4;
}
.inline-img06 img {
  height: 200px;
  width: auto;
  z-index: 4;
  /* background-color: palegreen; */
}

.inline-img07 {
  position: absolute;
  top: 500px;
  left: 30px;
}
.inline-img07 img {
  height: 150px;
  width: auto;
  /* background-color: plum; */
}

.inline-img08 {
  position: absolute;
  top: 600px;
  left: 500px;
}
.inline-img08 img {
  height: 200px;
  width: auto;
}

.inline-img09 {
  position: absolute;
  top: 750px;
  left: 50px;
}
.inline-img09 img {
  height: 200px;
  width: auto;
}

.inline-img10 {
  position: absolute;
  top: 600px;
  left: 700px;
}
.inline-img10 img {
  height: 400px;
  width: auto;
}

.inline-sel {
  width: 170px;
  height: auto;
}
.inline-sel img {
  height: auto;
  width: 150px;
}
.inline-sel p {
  text-align: center;
}
.sub-title-text {
  font-size: 20px;
  padding-left: 25px;
  padding-top: 5px;
  padding-bottom: 5px;
}
.mistake-text {
  font-weight: bold;
  color: #d32f2f;
  font-size: 30px;
  padding: 15px 20px;
  background-color: #ffebee;
  border-left: 5px solid #d32f2f;
  border-radius: 4px;
  animation: shake 0.5s ease-in-out;
  text-align: center;
}

@keyframes shake {
  0%, 100% { transform: translateX(0); }
  10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
  20%, 40%, 60%, 80% { transform: translateX(5px); }
}

/* Success feedback animation */
@keyframes successPulse {
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.05); opacity: 0.9; }
  100% { transform: scale(1); opacity: 1; }
}

.success-text {
  font-weight: bold;
  color: #2e7d32;
  font-size: 30px;
  padding: 15px 20px;
  background-color: #e8f5e9;
  border-left: 5px solid #2e7d32;
  border-radius: 4px;
  animation: successPulse 0.5s ease-in-out;
  text-align: center;
}

/*1023px以下 - WordPress iframe対応（840px想定）*/
@media screen and (max-width: 1023px) {
  .map {
    width: 100%;
    max-width: 100%;
  }

  .map img {
    width: 100%;
    height: auto;
  }

  .v-card-title {
    font-weight: 700;
  }

  .inline-img01 {
    position: absolute;
    top: 50px;
    left: 0px;
    z-index: 1;
  }
  .inline-img01 img {
    height: 150px;
    width: auto;
    z-index: 1;
  }

  .inline-img02 {
    position: absolute;
    top: 230px;
    left: 10px;
    z-index: 2;
  }
  .inline-img02 img {
    height: auto;
    width: 450px;
    z-index: 2;
    /* background-color: blue; */
  }

  .inline-img03 {
    position: absolute;
    top: 50px;
    left: 575px;
    z-index: 3;
  }
  .inline-img03 img {
    height: 220px;
    width: auto;
    z-index: 3;
  }

  .inline-img04 {
    position: absolute;
    top: 300px;
    left: 50px;
    z-index: 4;
  }
  .inline-img04 img {
    height: 200px;
    width: auto;
    z-index: 4;
    /* background-color: green; */
  }

  .inline-img05 {
    position: absolute;
    top: 300px;
    left: 700px;
    z-index: 5;
  }
  .inline-img05 img {
    height: 150px;
    width: auto;
    z-index: 5;
    /* background-color: red; */
  }

  .inline-img06 {
    position: absolute;
    top: 0px;
    left: 500px;
    z-index: 4;
  }
  .inline-img06 img {
    height: 200px;
    width: auto;
    z-index: 4;
    /* background-color: palegreen; */
  }

  .inline-img07 {
    position: absolute;
    top: 500px;
    left: 30px;
  }
  .inline-img07 img {
    height: 150px;
    width: auto;
    /* background-color: plum; */
  }

  .inline-img08 {
    position: absolute;
    top: 600px;
    left: 500px;
  }
  .inline-img08 img {
    height: 200px;
    width: auto;
  }

  .inline-img09 {
    position: absolute;
    top: 750px;
    left: 50px;
  }
  .inline-img09 img {
    height: 200px;
    width: auto;
  }

  .inline-img10 {
    position: absolute;
    top: 600px;
    left: 700px;
  }
  .inline-img10 img {
    height: 400px;
    width: auto;
  }

  .inline-sel img {
    height: auto;
    width: 150px;
  }
}

/*834px以下 - タブレット・スマホ対応*/
@media screen and (max-width: 834px) {
  .map {
    width: 100%;
    padding: 0;
  }

  .map img {
    width: 100%;
    height: auto;
  }

  /* タッチ領域の拡大 */
  .inline-img01, .inline-img02, .inline-img03, .inline-img04, .inline-img05,
  .inline-img06, .inline-img07, .inline-img08, .inline-img09, .inline-img10 {
    min-width: 44px;
    min-height: 44px;
  }

  /* 進捗カウンターの調整 */
  .progress-counter {
    top: 10px;
    right: 10px;
    min-width: 150px;
    padding: 10px;
    border-width: 2px;  /* 小画面では枠を細く */
  }

  .progress-chip {
    font-size: 12px !important;
  }

  .inline-img01 {
    position: absolute;
    top: 30px;
    left: 0px;
    z-index: 1;
  }
  .inline-img01 img {
    height: 130px;
    width: auto;
    z-index: 1;
  }

  .inline-img02 {
    position: absolute;
    top: 200px;
    left: 10px;
    z-index: 2;
  }
  .inline-img02 img {
    height: auto;
    width: 400px;
    z-index: 2;
    /* background-color: blue; */
  }

  .inline-img03 {
    position: absolute;
    top: 60px;
    left: 518px;
    z-index: 3;
  }
  .inline-img03 img {
    height: 160px;
    width: auto;
    z-index: 3;
  }

  .inline-img04 {
    position: absolute;
    top: 250px;
    left: 50px;
    z-index: 4;
  }
  .inline-img04 img {
    height: 170px;
    width: auto;
    z-index: 4;
    /* background-color: green; */
  }

  .inline-img05 {
    position: absolute;
    top: 250px;
    left: 600px;
    z-index: 5;
  }
  .inline-img05 img {
    height: 120px;
    width: auto;
    z-index: 5;
    /* background-color: red; */
  }

  .inline-img06 {
    position: absolute;
    top: 0px;
    left: 360px;
    z-index: 4;
  }
  .inline-img06 img {
    height: 150px;
    width: auto;
    z-index: 4;
    /* background-color: palegreen; */
  }

  .inline-img07 {
    position: absolute;
    top: 400px;
    left: 30px;
  }
  .inline-img07 img {
    height: 130px;
    width: auto;
    /* background-color: plum; */
  }

  .inline-img08 {
    position: absolute;
    top: 400px;
    left: 500px;
  }
  .inline-img08 img {
    height: 200px;
    width: auto;
  }

  .inline-img09 {
    position: absolute;
    top: 610px;
    left: 50px;
  }
  .inline-img09 img {
    height: 200px;
    width: auto;
  }

  .inline-img10 {
    position: absolute;
    top: 470px;
    left: 615px;
  }
  .inline-img10 img {
    height: 300px;
    width: auto;
  }

  .inline-sel {
    width: 190px;
  }
  .inline-sel img {
    height: auto;
    width: 150px;
  }
  .sub-title-text {
    font-size: 20px;
    padding-left: 25px;
  }
}

/*740px以下*/
@media screen and (max-width: 740px) {
  /*必要ならばここにコードを書く*/
  .map img {
    width: 100%;
    height: auto;
  }

  .inline-img01 {
    position: absolute;
    top: 40px;
    left: 0px;
    z-index: 1;
  }
  .inline-img01 img {
    height: 110px;
    width: auto;
    z-index: 1;
  }

  .inline-img02 {
    position: absolute;
    top: 180px;
    left: 10px;
    z-index: 2;
  }
  .inline-img02 img {
    height: auto;
    width: 330px;
    z-index: 2;
    /* background-color: blue; */
  }

  .inline-img03 {
    position: absolute;
    top: 40px;
    left: 418px;
    z-index: 3;
  }
  .inline-img03 img {
    height: 160px;
    width: auto;
    z-index: 3;
  }

  .inline-img04 {
    position: absolute;
    top: 220px;
    left: 50px;
    z-index: 4;
  }
  .inline-img04 img {
    height: 130px;
    width: auto;
    z-index: 4;
    /* background-color: green; */
  }

  .inline-img05 {
    position: absolute;
    top: 210px;
    left: 540px;
    z-index: 5;
  }
  .inline-img05 img {
    height: 100px;
    width: auto;
    z-index: 5;
    /* background-color: red; */
  }

  .inline-img06 {
    position: absolute;
    top: 0px;
    left: 320px;
    z-index: 4;
  }
  .inline-img06 img {
    height: 140px;
    width: auto;
    z-index: 4;
    /* background-color: palegreen; */
  }

  .inline-img07 {
    position: absolute;
    top: 360px;
    left: 30px;
  }
  .inline-img07 img {
    height: 100px;
    width: auto;
    /* background-color: plum; */
  }

  .inline-img08 {
    position: absolute;
    top: 400px;
    left: 420px;
  }
  .inline-img08 img {
    height: 150px;
    width: auto;
  }

  .inline-img09 {
    position: absolute;
    top: 550px;
    left: 50px;
  }
  .inline-img09 img {
    height: 150px;
    width: auto;
  }

  .inline-img10 {
    position: absolute;
    top: 430px;
    left: 550px;
  }
  .inline-img10 img {
    height: 250px;
    width: auto;
  }

  .inline-sel {
    width: 185px;
  }
  .inline-sel img {
    height: auto;
    width: 120px;
  }
}

/*640px以下*/
@media screen and (max-width: 640px) {
  /*必要ならばここにコードを書く*/
  .map img {
    width: 100%;
    height: auto;
  }

  .inline-img01 {
    position: absolute;
    top: 30px;
    left: 0px;
    z-index: 1;
  }
  .inline-img01 img {
    height: 100px;
    width: auto;
    z-index: 1;
  }

  .inline-img02 {
    position: absolute;
    top: 150px;
    left: 10px;
    z-index: 2;
  }
  .inline-img02 img {
    height: auto;
    width: 300px;
    z-index: 2;
    /* background-color: blue; */
  }

  .inline-img03 {
    position: absolute;
    top: 35px;
    left: 367px;
    z-index: 3;
  }
  .inline-img03 img {
    height: 130px;
    width: auto;
    z-index: 3;
  }

  .inline-img04 {
    position: absolute;
    top: 200px;
    left: 50px;
    z-index: 4;
  }
  .inline-img04 img {
    height: 120px;
    width: auto;
    z-index: 4;
    /* background-color: green; */
  }

  .inline-img05 {
    position: absolute;
    top: 180px;
    left: 430px;
    z-index: 5;
  }
  .inline-img05 img {
    height: 100px;
    width: auto;
    z-index: 5;
    /* background-color: red; */
  }

  .inline-img06 {
    position: absolute;
    top: 0px;
    left: 320px;
    z-index: 4;
  }
  .inline-img06 img {
    height: 110px;
    width: auto;
    z-index: 4;
    /* background-color: palegreen; */
  }

  .inline-img07 {
    position: absolute;
    top: 330px;
    left: 30px;
  }
  .inline-img07 img {
    height: 100px;
    width: auto;
    /* background-color: plum; */
  }

  .inline-img08 {
    position: absolute;
    top: 320px;
    left: 350px;
  }
  .inline-img08 img {
    height: 150px;
    width: auto;
  }

  .inline-img09 {
    position: absolute;
    top: 460px;
    left: 50px;
  }
  .inline-img09 img {
    height: 150px;
    width: auto;
  }

  .inline-img10 {
    position: absolute;
    top: 375px;
    left: 480px;
  }
  .inline-img10 img {
    height: 200px;
    width: auto;
  }
  .inline-sel {
    width: 170px;
    height: auto;
  }
  .inline-sel img {
    height: 120px;
    width: auto;
    margin: 10px;
  }
}

/*480px以下*/
@media screen and (max-width: 480px) {
  /*必要ならばここにコードを書く*/
  .map img {
    width: 100%;
    height: auto;
  }

  .inline-img01 {
    position: absolute;
    top: 25px;
    left: 0px;
    z-index: 1;
  }
  .inline-img01 img {
    height: 70px;
    width: auto;
    z-index: 1;
  }

  .inline-img02 {
    position: absolute;
    top: 100px;
    left: 10px;
    z-index: 2;
  }
  .inline-img02 img {
    height: auto;
    width: 190px;
    z-index: 2;
    /* background-color: blue; */
  }

  .inline-img03 {
    position: absolute;
    top: 45px;
    left: 320px;
    z-index: 3;
  }
  .inline-img03 img {
    height: 80px;
    width: auto;
    z-index: 3;
  }

  .inline-img04 {
    position: absolute;
    top: 130px;
    left: 20px;
    z-index: 4;
  }
  .inline-img04 img {
    height: 90px;
    width: auto;
    z-index: 4;
    /* background-color: green; */
  }

  .inline-img05 {
    position: absolute;
    top: 140px;
    left: 345px;
    z-index: 5;
  }
  .inline-img05 img {
    height: 70px;
    width: auto;
    z-index: 5;
    /* background-color: red; */
  }

  .inline-img06 {
    position: absolute;
    top: 0px;
    left: 240px;
    z-index: 4;
  }
  .inline-img06 img {
    height: 85px;
    width: auto;
    z-index: 4;
    /* background-color: palegreen; */
  }

  .inline-img07 {
    position: absolute;
    top: 255px;
    left: 10px;
  }
  .inline-img07 img {
    height: 70px;
    width: auto;
    /* background-color: plum; */
  }

  .inline-img08 {
    position: absolute;
    top: 280px;
    left: 295px;
  }
  .inline-img08 img {
    height: 100px;
    width: auto;
  }

  .inline-img09 {
    position: absolute;
    top: 390px;
    left: 20px;
  }
  .inline-img09 img {
    height: 80px;
    width: auto;
  }

  .inline-img10 {
    position: absolute;
    top: 295px;
    left: 375px;
  }
  .inline-img10 img {
    height: 150px;
    width: auto;
  }

  .inline-sel img {
    height: auto;
    width: 75px;
  }
}

/*385px以下*/
@media screen and (max-width: 385px) {
  .inline-img03 {
    top: 10px;
    left: 220px;
  }
  .inline-img05 {
    top: 110px;
    left: 245px;
  }
  .inline-img06 {
    left: 180px;
  }
  .inline-img08 {
    top: 215px;
  }
  .inline-img08 {
    top: 210px;
    left: 180px;
  }
  .inline-img09 {
    top: 290px;
  }
  .inline-img10 {
    top: 200px;
    left: 270px;
  }
  .inline-sel {
    font-size: 10px;
    width: 65px;
  }
  .inline-sel img {
    height: auto;
    width: 50px;
  }
  .sub-title-text {
    font-size: 10px;
    padding-left: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  /* Vuetifyのスタイルを上書き */
  .v-card__title {
    line-height: 1rem;
    font-size: 10px;
  }
  .v-application .text-h5 {
    font-size: 10px !important;
  }
  .congrats-msg {
    font-size: 1rem;
    padding: 1rem;
  }
  .congrats-msg-close {
    margin-top: 0.5rem !important;
    min-width: 80px !important;
  }
  .congrats-msg-close :deep(.v-btn__content) {
    font-size: 14px !important;
  }
}

/*320px以下*/
@media screen and (max-width: 320px) {
  .congrats-msg {
    font-size: 1rem;
    padding: 1rem;
  }
  .congrats-msg-close {
    margin-top: 0.5rem !important;
    min-width: 80px !important;
  }
  .congrats-msg-close :deep(.v-btn__content) {
    font-size: 14px !important;
  }
  /*必要ならばここにコードを書く*/
  .map img {
    width: 100%;
    height: auto;
  }

  .inline-img01 {
    position: absolute;
    top: 20px;
    left: 0px;
    z-index: 1;
  }
  .inline-img01 img {
    height: 40px;
    width: auto;
    z-index: 1;
  }

  .inline-img02 {
    position: absolute;
    top: 60px;
    left: 10px;
    z-index: 2;
  }
  .inline-img02 img {
    height: auto;
    width: 100px;
    z-index: 2;
    /* background-color: blue; */
  }

  .inline-img03 {
    position: absolute;
    top: 10px;
    left: 180px;
    z-index: 3;
  }
  .inline-img03 img {
    height: 60px;
    width: auto;
    z-index: 3;
  }

  .inline-img04 {
    position: absolute;
    top: 90px;
    left: 20px;
    z-index: 4;
  }
  .inline-img04 img {
    height: 50px;
    width: auto;
    z-index: 4;
    /* background-color: green; */
  }

  .inline-img05 {
    position: absolute;
    top: 90px;
    left: 220px;
    z-index: 5;
  }
  .inline-img05 img {
    height: 35px;
    width: auto;
    z-index: 5;
    /* background-color: red; */
  }

  .inline-img06 {
    position: absolute;
    top: 0px;
    left: 120px;
    z-index: 4;
  }
  .inline-img06 img {
    height: 50px;
    width: auto;
    z-index: 4;
    /* background-color: palegreen; */
  }

  .inline-img07 {
    position: absolute;
    top: 150px;
    left: 10px;
  }
  .inline-img07 img {
    height: 40px;
    width: auto;
    /* background-color: plum; */
  }

  .inline-img08 {
    position: absolute;
    top: 160px;
    left: 160px;
  }
  .inline-img08 img {
    height: 70px;
    width: auto;
  }

  .inline-img09 {
    position: absolute;
    top: 230px;
    left: 20px;
  }
  .inline-img09 img {
    height: 60px;
    width: auto;
  }

  .inline-img10 {
    position: absolute;
    top: 190px;
    left: 230px;
  }
  .inline-img10 img {
    height: 90px;
    width: auto;
  }

  .inline-sel {
    font-size: 10px;
    width: 65px;
  }
  .inline-sel img {
    height: auto;
    width: 50px;
  }
  .sub-title-text {
    font-size: 10px;
    padding-left: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  /* Vuetifyのスタイルを上書き */
  .v-card__title {
    line-height: 1rem;
    font-size: 10px;
  }
  .v-application .text-h5 {
    font-size: 10px !important;
  }
}

/*280px以下*/
@media screen and (max-width: 280px) {
  .congrats-msg {
    font-size: 0.875rem;
    padding: 0.75rem;
  }
  .congrats-msg-close {
    margin-top: 0.5rem !important;
    min-width: 70px !important;
  }
  .congrats-msg-close :deep(.v-btn__content) {
    font-size: 12px !important;
  }
  /*必要ならばここにコードを書く*/
  .map img {
    width: 100%;
    height: auto;
  }

  .inline-img01 {
    position: absolute;
    top: 20px;
    left: 0px;
    z-index: 1;
  }
  .inline-img01 img {
    height: 40px;
    width: auto;
    z-index: 1;
  }

  .inline-img02 {
    position: absolute;
    top: 60px;
    left: 10px;
    z-index: 2;
  }
  .inline-img02 img {
    height: auto;
    width: 100px;
    z-index: 2;
    /* background-color: blue; */
  }

  .inline-img03 {
    position: absolute;
    top: 10px;
    left: 155px;
    z-index: 3;
  }
  .inline-img03 img {
    height: 60px;
    width: auto;
    z-index: 3;
  }

  .inline-img04 {
    position: absolute;
    top: 90px;
    left: 20px;
    z-index: 4;
  }
  .inline-img04 img {
    height: 50px;
    width: auto;
    z-index: 4;
    /* background-color: green; */
  }

  .inline-img05 {
    position: absolute;
    top: 90px;
    left: 190px;
    z-index: 5;
  }
  .inline-img05 img {
    height: 35px;
    width: auto;
    z-index: 5;
    /* background-color: red; */
  }

  .inline-img06 {
    position: absolute;
    top: 0px;
    left: 120px;
    z-index: 4;
  }
  .inline-img06 img {
    height: 50px;
    width: auto;
    z-index: 4;
    /* background-color: palegreen; */
  }

  .inline-img07 {
    position: absolute;
    top: 150px;
    left: 10px;
  }
  .inline-img07 img {
    height: 40px;
    width: auto;
    /* background-color: plum; */
  }

  .inline-img08 {
    position: absolute;
    top: 160px;
    left: 160px;
  }
  .inline-img08 img {
    height: 70px;
    width: auto;
  }

  .inline-img09 {
    position: absolute;
    top: 210px;
    left: 20px;
  }
  .inline-img09 img {
    height: 60px;
    width: auto;
  }

  .inline-img10 {
    position: absolute;
    top: 170px;
    left: 210px;
  }
  .inline-img10 img {
    height: 90px;
    width: auto;
  }

  .inline-sel {
    font-size: 10px;
    width: 65px;
  }
  .inline-sel img {
    height: auto;
    width: 50px;
  }
  .sub-title-text {
    font-size: 10px;
    padding-left: 10px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  /* Vuetifyのスタイルを上書き */
  .v-card__title {
    line-height: 1rem;
    font-size: 10px;
  }
  .v-application .text-h5 {
    font-size: 10px !important;
  }
}

/* ダイアログ操作のための画像は透明にする */
.switch_image {
  opacity: 0;
}

.animation {
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-duration: 1.5s;
  width: 128px;
}

.keyframe3 {
  animation-name: anim_s;
  transform: rotate(5deg);
  animation-duration: 5s;
}

@keyframes anim_s {
  50% {
    transform: rotate(-5deg);
  }
  100% {
    transform: rotate(5deg);
  }
}

/* エンジンのように細かく上に震わせるアニメーション */
.engine {
  animation: engine 0.2s infinite;
  -webkit-animation: engine 0.2s infinite;
  -moz-animation: engine 0.2s infinite;
}
@keyframes engine {
  0% {
    transform: scale(1, 1) translate(0%, 0%);
  }
  50% {
    transform: scale(1, 0.98) translate(0%, 1.5%);
  }
  100% {
    transform: scale(1, 1) translate(0%, 0%);
  }
}
@-webkit-keyframes engine {
  0% {
    -webkit-transform: scale(1, 1) translate(0%, 0%);
  }
  50% {
    -webkit-transform: scale(1, 0.98) translate(0%, 1.5%);
  }
  100% {
    -webkit-transform: scale(1, 1) translate(0%, 0%);
  }
}
@-moz-keyframes engine {
  0% {
    -moz-transform: scale(1, 1) translate(0%, 0%);
  }
  50% {
    -moz-transform: scale(1, 0.98) translate(0%, 1.5%);
  }
  100% {
    -moz-transform: scale(1, 1) translate(0%, 0%);
  }
}

/* 要素をキラリと光らせるアニメーション */
.tenmetsu {
  animation: flash 3s linear infinite;
}
@keyframes flash {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
  100% {
    opacity: 1;
  }
}

.hoge-enter-active,
.hoge-leave-active {
  transition: opacity 0.5s;
}

.hoge-enter,
.hoge-leave-to {
  opacity: 0;
}

/* Progress Counter Styles - iframe対応でabsoluteに変更 */
.progress-counter {
  position: absolute;  /* fixedからabsoluteに変更（iframe内対応） */
  top: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-width: 200px;
  background-color: #ffffff;  /* 白背景 */
  padding: 12px;
  border: 3px solid #000000;  /* 黒枠 */
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);  /* 影を強調 */
}

.progress-chip {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.progress-bar {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: all 0.5s ease;
  background-color: #e0e0e0 !important;  /* プログレスバー背景色 */
}

.progress-bar :deep(.v-progress-linear__determinate) {
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
}

/* Hover Effects for Clickable Images */
.inline-img01,
.inline-img02,
.inline-img03,
.inline-img04,
.inline-img05,
.inline-img06,
.inline-img07,
.inline-img08,
.inline-img09,
.inline-img10 {
  cursor: pointer;
  transition: all 0.3s ease;
}

.inline-img01:hover,
.inline-img02:hover,
.inline-img03:hover,
.inline-img04:hover,
.inline-img05:hover,
.inline-img06:hover,
.inline-img07:hover,
.inline-img08:hover,
.inline-img09:hover,
.inline-img10:hover {
  transform: scale(1.05);
  filter: brightness(1.1);
}

/* Focus indicators for keyboard accessibility */
.switch_image:focus {
  outline: 3px solid #2196F3;
  outline-offset: 4px;
  border-radius: 8px;
}

.switch_image:focus:not(:focus-visible) {
  outline: none;
}

.switch_image:focus-visible {
  outline: 3px solid #2196F3;
  outline-offset: 4px;
  border-radius: 8px;
}

/* Solved image styling */
.solved-image {
  filter: saturate(1.2) brightness(1.1);
}

/* Responsive adjustments for progress counter */
@media screen and (max-width: 834px) {
  .progress-counter {
    top: 10px;
    right: 10px;
    min-width: 150px;
    padding: 10px;
    border-width: 2px;  /* 小画面では枠を細く */
  }

  .progress-chip {
    font-size: 12px !important;
  }
}

/* スマートフォンでは進捗カウンターを非表示 */
@media screen and (max-width: 480px) {
  .progress-counter {
    display: none;
  }
}
</style>